import React, { useRef, useState, useEffect } from 'react';
import { EditProfileImage } from '../../components/superadmin';
import { TbTrashX } from "react-icons/tb";
import { BiCloudUpload } from "react-icons/bi";
import { useFormik } from "formik"
import { useParams, useNavigate } from 'react-router-dom';
import { handleApi } from '../../utils/authentication';
import * as Yup from 'yup'
import { toast } from "react-toastify"
import { BsPersonLock } from "react-icons/bs";
import Select from "react-select"
import { customStyles } from '../../utils/select_style';
import user_default from "../../assests/user_default.png"
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import {getdateOneYearFromDate} from "../../utils/date_format"
import users from "../../assests/users.png"
import calender from "../../assests/calender.svg"



const SuperAdminClientEditProfile = () => {
  const profileImageRef = useRef(null);
  const [imageUri, setImageUri] = useState('');
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    first_name: '',
    last_name: '',
    website: '',
    email: '',
    client_name: ''

  })
  const navigate = useNavigate()
  const { client_id } = useParams()



  const getClientData = async () => {
    try {
      if (client_id) {
        let method = "POST"
        let headers = {}
        let formdata = new FormData()
        formdata.append('client_id', client_id)
        let result = await handleApi(`view_client`, method, headers, formdata)
        if (result?.success) {

          setInitialValues({
            first_name: result?.data?.client_info?.owner_first_name ?? '',
            last_name: result?.data?.client_info?.owner_last_name  ?? '',
            website: result?.data?.client_info?.website  ?? '',
            email: result?.data?.client_info?.owner_invite_email  ?? '',
            client_name: result?.data?.client_info?.client_name  ?? '',
            total_members:result?.data?.client_info?.total_members  ?? 0,
            subscription_start_date:result?.data?.client_info?.subscription_start_date?format(new Date(result?.data?.client_info?.subscription_start_date),'yyyy-MM-dd'):'',
             subscription_end_date:result?.data?.client_info?.subscription_end_date?format(new Date(result?.data?.client_info?.subscription_end_date),'yyyy-MM-dd'):'',
             is_agency:result?.data?.client_info?.is_agency?"yes":"no",
             subscription_value:result?.data?.client_info?.subscription_value  ?? 0,
             is_blocked:result?.data?.client_info?.is_blocked?{label:"Block",value:1}:{label:"Active",value:0}
          })
          if (result?.data?.client_info?.client_logo_path) {
            
            setImageUri( result?.data?.client_info?.client_logo_path)
          }


        }
        else {
          toast.error("Failed to load customer details", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          return
        }
      }

    }
    catch (e) {
      console.log(e)
      toast.error(e?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    }


  }


  const handleDeleteImage = () => {
    if (imageUri) {
      setImageUri('')
    }

  }
  //reads the image and opens the modal by setting setShow-> true
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
  
    if (file) {

      if (!file.type.startsWith("image/")) {
        toast.error("Only image files are allowed!");
        event.target.value = ""; // clear invalid file
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUri(reader.result);
        setShow(true) // Set the image URI in state
      };
      reader.readAsDataURL(file); // Read the file as a data URL
      setFile(file)
    }
     event.target.value=''
  }

  const handleClientDataUpdate = async () => {
    try {
      setLoading(true);  // Start loading
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      if (imageUri && file) {
        let response = await fetch(imageUri);
        let image_file = await response.blob();
        formData.append('client_logo', image_file, file?.name);
      }
      // if (!imageUri) {
      //   toast.error(" Please Upload Logo ", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "light",
      //   })
      //   return

      // }
      formData.append('client_id', client_id);
      formData.append('client_name', formik.values.client_name);
      formData.append('first_name', formik.values.first_name);
      formData.append('last_name', formik.values.last_name);
      formData.append('email', formik.values.email);
      formData.append('website', formik.values.website);
      formData.append('subscription_start_date', format(new Date(formik?.values?.subscription_start_date),'yyyy-MM-dd'));
      formData.append('subscription_end_date', format(new Date(formik?.values?.subscription_end_date),'yyyy-MM-dd'));
      formData.append('total_members', formik.values.total_members);
      formData.append('subscription_value', formik.values.subscription_value);
      formData.append('is_blocked', formik.values.is_blocked?.value);
      
      if(formik?.values?.is_agency==="yes")
      {
        
      formData.append('is_agency',1);

      }else{
        formData.append('is_agency',0);

      }

      let result = await handleApi('edit_client', method, headers, formData);

      if (result?.success) {
        toast.success('Account Updated Successfully.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate('/super_admin/clients');
      } else {
        toast.error(result?.error?.error_message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (e) {
      toast.error(e.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);  // Stop loading
    }
  }

  //formik form validation
  const validationSchema = Yup.object({
    client_name: Yup.string().required('Client Name is Required'),
    first_name: Yup.string().required('Firstname is Required').matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
    last_name: Yup.string().required('Lastname is Required').matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
    email: Yup.string().email('Invalid email address').required('Email is Required'),
    subscription_start_date:Yup.date().required('Start subscription date is required'),
    subscription_end_date: Yup.date()
    .required('End Subscription date is required')
    .nullable()
    .min(Yup.ref('subscription_start_date'), 'End Subscription date must be grater than start subscription date'),
    total_members: Yup.number().required('Total Members is Required').moreThan(0, 'Number must be greater than 0'),
    subscription_value:Yup.number().required("Subscription Value is required").moreThan(0, 'Number must be greater than 0'),
     is_blocked:Yup.object({label:Yup.string().required(),value:Yup.number().required().min(0).max(1)})
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
   //   console.log(values)
      handleClientDataUpdate()
    },
  });
  useEffect(() => {
    getClientData()

  }, [client_id])

  useEffect(() => {
    formik.setValues(initialValues);
  }, [initialValues]);

  return (
    <form onSubmit={formik.handleSubmit}>

      <div className='w-100 h-100 position-relative d-flex flex-column align-items-center '>
        <EditProfileImage show={show} setShow={setShow} uri={imageUri} setImageUri={setImageUri} />
        <div className='card card super_admin_profile_card '>
          <div>
            <h5 className='pb-0'>Main Info</h5>
          </div>
          {/* profile image */}
          <div className='row border-1 border-bottom pb-4'>
            <div className='col-xl-2 d-flex justify-content-center justify-content-xl-start   '>
             <div    style={{
                  height:'64px',
                  width:'auto',
                  borderRadius:'0%',
                  position:'relative'
                }}>
             <img
                src={imageUri ? imageUri : user_default} // Use the image URI for the src
                alt="Profile"
                style={{width:'100%',height:'100%',objectFit:'contain'}}
                onError={()=>{
                  setImageUri(null)
                }}
              // Add cursor style for better UX
              />

             </div>
            
              <input
                ref={profileImageRef}
                type="file"
                id="profile_image"
                className='d-none'
                accept="image/*"
                onChange={handleImageUpload} // Add the onChange handler
              />

            </div>
            <div className=' col-xl-7 row d-flex align-items-end m-0 '>
              <div className='col-12 col-md-6 mb-2'>
                <button type="button" disabled={imageUri ? false : true} className={`w-100 ${!imageUri && "disable_btn"} btn btn-outline-custom btn-outline-primary  rounded-pill d-flex  justify-content-center align-items-center gap-1`} onClick={handleDeleteImage} ><TbTrashX /> Delete Image</button>
              </div>
              <div className='col6 col-md-6  mb-2 '>
                <button type="button" onClick={() => {
                  profileImageRef.current.click();
                }} className='w-100 py-2 btn btn-primary rounded-pill d-flex   justify-content-center  align-items-center  gap-1 '> <BiCloudUpload /> Upload New Image</button>
              </div>



            </div>
       

          </div>
          <div className="mb-1 row">
            <label htmlFor="client_name" className="col-lg-3  col-form-label">Client Name*</label>
            <div className="col-lg-6 ">
              <input type="text"
                className="form-control"
                id="client_name"
                placeholder='Client Name'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.client_name}

              />
               {formik.touched.client_name && formik.errors.client_name ? (
                  <div className='text-danger text-start small'>{formik.errors.client_name}</div>
                ) : null}
            </div>
           
          </div>
          <div className="mb-1 row">
            <label htmlFor="first_name" className="col-lg-3  col-form-label">Client Admin First Name*</label>
            <div className="col-lg-6 ">
              <input type="text"
                className="form-control"
                id="first_name"
                placeholder='Firstname'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.first_name}

              />
                {formik.touched.first_name && formik.errors.first_name ? (
                  <div className='text-danger text-start small'>{formik.errors.first_name}</div>
                ) : null}
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="last_name" className="col-lg-3 col-form-label">Client Admin Last Name*</label>
            <div className="col-lg-6 ">
              <input type="text"
                className="form-control"
                id="last_name"
                placeholder='Lastname'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.last_name}


              />
              {formik.touched.last_name && formik.errors.last_name ? (
                  <div className='text-danger text-start small'>{formik.errors.last_name}</div>
                ) : null}
              
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="email" className="col-lg-3 col-form-label">Admin Email*</label>
            <div className="col-lg-6 ">
              <input type="email"
                className="form-control"
                id="email"
                placeholder='Email'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                disabled
              />
                {formik.touched.email && formik.errors.email ? (
                  <div className='text-danger text-start small'>{formik.errors.email}</div>
                ) : null}
              
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="website" className="col-lg-3 col-form-label">Website</label>
            <div className="col-lg-6 ">
              <input type="website"
                className="form-control"
                id="text"
                placeholder='Website'
                name="website"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.website?formik.values.website:''}

              />
                 {formik.touched.website && formik.errors.website ? (
                  <div className='text-danger text-start small'>{formik.errors.website}</div>
                ) : null}
            </div>
          </div>
     


          <div className="mb-1 row">
              <label htmlFor="website" className="col-lg-3 col-form-label">Subscription Start Date*</label>
              <div className="col-lg-6">
                <div className='position-relative'>
                <DatePicker  
                    showIcon={false}
                    
                    selected={formik.values.subscription_start_date}
                    // minDate={}
                    onChange={(date) => 
                      {
                       
                        formik.setFieldValue('subscription_start_date', date)
                        // formik.setFieldValue('subscription_end_date',  getdateOneYearFromDate(format(date,'yyyy-MM-dd')))
                       

                      }  }
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select Subscription Start Date"
                      className='form-control'
                    
                    
                    />
                       <div className='calender_icon'>
                      <img src={calender} alt="" srcset="" />

                    </div>

                </div>
              
                       {formik.touched.subscription_start_date && formik.errors.subscription_start_date ? (
                  <div className='text-danger text-start small'>{formik.errors.subscription_start_date}</div>
                ) : null}
              
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="website" className="col-lg-3 col-form-label">Subscription Expiration Date*</label>
              <div className="col-lg-6">
            <div className='position-relative d-flex'>
            <DatePicker  
                     showIcon={false}
                    
                    selected={formik.values.subscription_end_date}
                    minDate={formik.values.subscription_start_date}
                    onChange={(date) => 
                      {
                       
                        formik.setFieldValue('subscription_end_date', date)

                      }  }
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select Subscription Expiration Date"
                      className='form-control'
                    
                    
                    />
                    <div className='calender_icon'>
                      <img src={calender} alt="" srcset="" />

                    </div>

            </div>
             
                        {formik.touched.subscription_end_date && formik.errors.subscription_end_date ? (
                  <div className='text-danger text-start small'>{formik.errors.subscription_end_date}</div>
                ) : null}
              
              </div>
            </div>
            <div className="mb-1 row">
            <label htmlFor="subscription_value" className="col-lg-3 col-form-label">Subscription Value ( In $ )*</label>
            <div className="col-lg-6 ">
              <input type="number"
                className="form-control"
                id="subscription_value"
                min={0}
                placeholder='Subscription Value'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.subscription_value}

              />
                  {formik.touched.subscription_value && formik.errors.subscription_value ? (
                  <div className='text-danger text-start small'>{formik.errors.subscription_value}</div>
                ) : null}
            </div>
               
        
          </div>
            <div className="mb-1 row">
              <label htmlFor="total_members" className="col-lg-3 col-form-label">Members Count*</label>
              <div className="col-lg-6 ">
                <div className='position-relative d-flex'>
                <input type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.total_members}
                  className="form-control"
                  id="total_members"
                  placeholder='Enter Members Count' />
                  <div className='input_user_icon'>
                  <img src={users} alt=""  />
                  </div>
               

                </div>
                
                {formik.touched.total_members && formik.errors.total_members ? (
                  <div className='text-danger text-start small'>{formik.errors.total_members}</div>
                ) : null}
                
              </div>
            </div>

            <div className="mb-1 row">
            <label htmlFor="subscription_value" className="col-lg-3 col-form-label">Total Subscription Value ( In $ )*</label>
            <div className="col-lg-6 ">
              {/* <input type="number"
                className="form-control"
                id="subscription_value"
                min={0}
                placeholder='Subscription Value'
                // onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                value={formik.values?.subscription_value*formik.values?.total_members}

              /> */}
              <span className='fw-bold fs-6'>{formik.values?.subscription_value*formik.values?.total_members}$</span>
                  {/* {formik.touched.subscription_value && formik.errors.subscription_value ? (
                  <div className='text-danger text-start small'>{formik.errors.subscription_value}</div>
                ) : null} */}
            </div>
               
        
          </div>
            

            
            <div className="mb-1 row">
              <label htmlFor="total_members" className="col-lg-3 col-form-label">Is Agency</label>
              <div className="col-lg-6">
                <div className='d-flex gap-3 align-items-center'>
                  <div className='d-flex gap-3 align-items-center'>
                  <input type="radio" name="is_agency" id="is_agency_yes"
                  value="yes" 
                  checked={formik.values.is_agency === 'yes'} 
                  onChange={formik.handleChange} 
                    />
                    <label htmlFor="is_agency_yes">Yes</label>
                    
                  </div>
                  <div className='d-flex gap-3 align-items-center'>
                  <input type="radio" name="is_agency" id="is_agency_no" 
                  value="no" 
                  checked={formik.values.is_agency === 'no'} 
                  onChange={formik.handleChange} 
                   />
                    <label htmlFor="is_agency_no">No</label>
           
                  </div>
                </div>
             
              </div>
            </div>

  <div className="mb-1 row ">
              <label htmlFor="role" className="col-lg-3 col-form-label">Client Status*</label>
              <div className="col-lg-6">
          
                <Select
                 id="is_blocked"
                name="is_blocked"
                placeholder="Select Status"
                styles={customStyles}
                value={formik.values.is_blocked}
                options={[{label:"Active",value:0},{label:"Block",value:1}]}
                onChange={(selected_options) => {
                 
                  formik.setFieldValue('is_blocked', selected_options)

                }}
              

              />
                {formik.touched.is_blocked && formik.errors.is_blocked ? (
                  <div className='text-danger text-start small'>{formik.errors.is_blocked}</div>
                ) : null}
              </div>
            </div>
          <div className="mb-1 row mt-2">
            <div className='col-lg-9 d-flex justify-content-end'>
              {!loading ?
                <button type='submit' className='btn btn-primary rounded-pill px-5'>Update</button> :
                <button type='button' className='btn btn-primary rounded-pill px-5' disabled>processing...</button>}

            </div>
          </div>
        </div>
        {/* <div className='card profile_card px-3 my-2'>
          <div>
            <h5 className='pb-0'>Personal Info</h5>
          </div>
          <div className="mb-1 row">
            <label htmlFor="email" className=" col-lg-3  col-form-label">Email</label>
            <div className="col-lg-6">
              <input type="email" className="form-control" id="email" placeholder='Email' />
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="password" className="col-lg-3  col-form-label">Password</label>
            <div className="col-lg-6">
              <input type="password" className="form-control" id="password" placeholder='Password'  />
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="phone" className="col-lg-3  col-form-label">Phone</label>
            <div className="col-lg-6">
              <input type="text" className="form-control" id="phone" placeholder='ex:+08 987 678 90'  />
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="job" className="col-lg-3  col-form-label">Job</label>
            <div className="col-lg-6">
              <input type="text" className="form-control" id="job" placeholder='Developer' />
            </div>
          </div>

        </div> */}
        {/* <div className='card profile_card px-3 my-2'>
          <div>
            <h5 className='pb-0'>Reset Password</h5>
          </div>
          <div className="mb-1 row">
            <label htmlFor="old_password" className="col-lg-3  col-form-label">Old Password</label>
            <div className="col-lg-6">
              <input type="password" className="form-control" id="old_password" placeholder='Password' />
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="new_password" className="col-lg-3  col-form-label">New Password</label>
            <div className="col-lg-6">
              <input type="password" className="form-control" id="new_password" placeholder='New Password'  />
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="confirm_password" className="col-lg-3  col-form-label">Confirm Password</label>
            <div className="col-lg-6">
              <input type="pssword" className="form-control" id="confirm_password" placeholder='Confirm Password'  />
            </div>
          </div>
        </div> */}
        {/* <div className='card profile_card px-3 my-2'>
          <div>
            <h5 className='pb-0'>Address</h5>
          </div>
          <div className="mb-1 row">
            <label htmlFor="country" className="col-lg-3 col-form-label">Country</label>
            <div className="col-lg-6">
              <input type="text" className="form-control" id="country" placeholder='United States' />
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="city_state" className="col-lg-3  col-form-label">City/State</label>
            <div className="col-lg-6">
              <input type="text" className="form-control" id="city_state" placeholder='New York, NY' />
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="postal_code" className="col-lg-3  col-form-label">Postal Code</label>
            <div className="col-lg-6">
            <input type="text" className="form-control" id="postal_code" placeholder='NY 76432' />
            </div>
          </div>
     
    

        </div> */}
      </div>
    </form>
  );
};

export default SuperAdminClientEditProfile;
